module.exports = __webpack_public_path__ + "media/images/plan-36068ae819d96facb1576f88adbbd79a.svg";